/**
 * Whether the dashboard is running inside an iframe (i.e. embedded in the Rage
 * Live application) rather than as a standalone page.
 *
 * A cross-origin parent makes `window.top` access throw - which itself means we
 * are embedded, so that case returns true.
 */
export const isEmbedded = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

/**
 * Message the dashboard posts to its parent (the Rage app) when its session can
 * no longer be recovered, so Rage can re-issue a token / reload the embed. The
 * Rage side may listen for this; if it doesn't, nothing breaks - the embed just
 * shows a graceful "session expired" state instead of the dev login form.
 */
export const SESSION_EXPIRED_MESSAGE = 'RAGE_AI_DASHBOARD_SESSION_EXPIRED';

export const notifyParentSessionExpired = (): void => {
  if (!isEmbedded()) {
    return;
  }
  try {
    window.parent.postMessage({ type: SESSION_EXPIRED_MESSAGE }, '*');
  } catch {
    /* posting to a cross-origin parent can throw in some browsers - non-fatal */
  }
};
